<template>
  <div>
    <es-title title="Importação de Pagamentos">
      <template #right>
        <div class="button is-success" @click="abrirModalImportacao">
          <icon name="upload"></icon> &nbsp;&nbsp;Importar
        </div>
      </template>
    </es-title>

    <div class="importacao-totais">
      <span class="tag is-info is-medium">Total de pagamentos: {{ totalSelecionados }}</span>
      <span class="tag is-success is-medium">Valor do pagamento = {{ valorSelecionadoFormatado }}</span>
    </div>

    <es-table :config="tabela" :rows="pagamentos">
      <div slot="buttons" class="buttons">
        <div class="button is-link" @click="enviarParaAprovacao">
          <icon name="check-circle"></icon> &nbsp;&nbsp;Enviar para Aprovação
        </div>
        <div class="button is-danger" @click="deletarSelecionados">
          <icon name="trash"></icon> &nbsp;&nbsp;Deletar Pagamento
        </div>
      </div>
    </es-table>

    <es-modal title="Importação de Pagamentos" :config="modalImportacao">
      <div class="field">
        <div
          class="drop-zone"
          :class="{ 'is-dragover': arrastando }"
          @dragover.prevent="arrastando = true"
          @dragleave.prevent="arrastando = false"
          @drop.prevent="onDrop"
          @click="$refs.inputArquivo.click()"
        >
          <input
            ref="inputArquivo"
            class="file-input-hidden"
            type="file"
            accept=".xls,.xlsx"
            @change="onFileChange"
          >
          <icon name="cloud" scale="2.5"></icon>
          <p v-if="!arquivoSelecionado">Arraste a planilha aqui ou clique para selecionar</p>
          <p v-else class="has-text-weight-bold">{{ arquivoSelecionado.name }}</p>
          <span class="is-size-7">Somente um arquivo (.xls, .xlsx)</span>
        </div>
      </div>
    </es-modal>

    <es-modal title="Editar Pagamento" :config="modalEditar">
      <es-form :config="formEdicao"></es-form>
    </es-modal>

    <es-modal title="Excluir Pagamento" :config="modalExcluir">
      <p>Deseja realmente excluir este pagamento?</p>
      <p v-if="pagamentoSelecionado"><b>{{ pagamentoSelecionado.nome_favorecido }}</b></p>
    </es-modal>

    <es-loading :show="loading"></es-loading>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/utils'

export default {
  data () {
    return {
      pagamentos: [],
      statusLabels: {
        0: 'Gerar',
        1: 'Aguardando Aprovação',
        2: 'Enviado',
        3: 'Pendente',
        4: 'Aguardando Resposta do Banco',
        5: 'Pagamento Confirmado',
        6: 'Erro do Banco',
        7: 'Encerrado Manualmente',
        9: 'Importado',
        10: 'Excluído',
        99: 'Enviado para Aprovação'
      },
      arquivoSelecionado: null,
      arrastando: false,
      idxSelecionado: null,
      pagamentoSelecionado: null,
      camposObrigatoriosEdicao: [
        { name: 'uf', label: 'UF' },
        { name: 'documento', label: 'Documento' },
        { name: 'nome_favorecido', label: 'Favorecido' },
        { name: 'banco', label: 'Banco' },
        { name: 'agencia_numero', label: 'Agência' },
        { name: 'conta_numero', label: 'Conta' },
        { name: 'tipo_conta', label: 'Tipo de Conta' },
        { name: 'valor', label: 'Valor' },
        { name: 'conta_debito', label: 'Conta Débito' },
        { name: 'observacao', label: 'Observação' }
      ],
      tabela: {
        fields: [
          { name: 'id', label: 'Id', align: 'right' },
          { name: 'nome_apresentante', label: 'Nome Apresentante' },
          { name: 'nome_favorecido', label: 'Nome Favorecido' },
          { name: 'numero', label: 'Número', align: 'center' },
          { name: 'agencia', label: 'Agência', align: 'center' },
          { name: 'banco', label: 'Banco', align: 'center' },
          { name: 'valor', label: 'Valor', type: 'currency' },
          { name: 'importado_em', label: 'Importado em', type: 'datetime', align: 'center' },
          { name: 'enviado_por', label: 'Enviado por', align: 'center' },
          { name: 'status', label: 'Status', align: 'center' }
        ],
        key: 'id',
        toggle: 'selecionado',
        toggleIconOn: 'check-square',
        toggleIconOff: 'square',
        toggleColor: true,
        actions: [
          { action: this.editar, icon: 'edit' },
          { action: this.deletar, icon: 'trash' }
        ]
      },
      modalImportacao: {
        active: false,
        width: 'medium',
        cancel: this.limparImportacao,
        save: this.importar
      },
      modalEditar: {
        active: false,
        width: 'large',
        cancel: this.cancelarEdicao,
        save: this.salvarEdicao
      },
      modalExcluir: {
        active: false,
        width: 'small',
        cancel: this.cancelarExclusao,
        delete: this.confirmarExclusao
      },
      formEdicao: {
        data: {},
        row: {},
        levels: [
          {
            fields: [
              { name: 'nome_apresentante', label: 'Apresentante', type: 'text', width: 6 },
              {
                name: 'uf',
                label: 'UF *',
                type: 'select',
                width: 2,
                required: true,
                values: Object.keys(utils.ufs).map((uf) => ({ value: uf, text: uf }))
              },
              { name: 'documento', label: 'Documento *', type: 'text', width: 4, required: true }
            ]
          },
          {
            fields: [
              { name: 'nome_favorecido', label: 'Favorecido *', type: 'text', width: 12, required: true }
            ]
          },
          {
            fields: [
              { name: 'banco', label: 'Banco *', type: 'text', width: 2, required: true },
              { name: 'agencia_numero', label: 'Agência *', type: 'text', width: 3, required: true },
              { name: 'agencia_digito', label: 'Dígito', type: 'text', width: 2 },
              { name: 'conta_numero', label: 'Conta *', type: 'text', width: 3, required: true },
              { name: 'conta_digito', label: 'Dígito', type: 'text', width: 2 }
            ]
          },
          {
            fields: [
              {
                name: 'tipo_conta',
                label: 'Tipo de Conta *',
                type: 'select',
                width: 3,
                required: true,
                values: [
                  { value: 'C', text: 'Conta Corrente' },
                  { value: 'P', text: 'Conta Poupança' }
                ]
              },
              { name: 'valor', label: 'Valor *', type: 'text', width: 3, required: true },
              { name: 'conta_debito', label: 'Conta Débito *', type: 'text', width: 3, required: true },
              { name: 'observacao', label: 'Observação *', type: 'text', width: 3, required: true }
            ]
          }
        ]
      }
    }
  },
  created () {
    this.getPagamentos()
  },
  methods: {
    getPagamentos () {
      this.showLoading()
      axios.get('api/v1/batimento/pagamentos/importacao/').then((res) => {
        this.pagamentos = res.data.map((pagamento) => Object.assign({}, pagamento, {
          selecionado: true,
          status: this.statusLabels[pagamento.status] !== undefined ? this.statusLabels[pagamento.status] : pagamento.status
        }))
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao buscar pagamentos importados.')
        this.closeLoading()
      })
    },
    abrirModalImportacao () {
      this.limparImportacao()
      this.modalImportacao.active = true
    },
    limparImportacao () {
      this.arquivoSelecionado = null
      this.arrastando = false
      if (this.$refs.inputArquivo) {
        this.$refs.inputArquivo.value = ''
      }
    },
    onDrop (event) {
      this.arrastando = false
      this.selecionarArquivo(event.dataTransfer.files)
    },
    onFileChange (event) {
      this.selecionarArquivo(event.target.files)
    },
    selecionarArquivo (files) {
      if (!files || files.length === 0) {
        return
      }
      if (files.length > 1) {
        this.warning('Selecione somente uma planilha por vez.')
        return
      }
      var arquivo = files[0]
      if (!/\.(xls|xlsx)$/i.test(arquivo.name)) {
        this.warning('Selecione um arquivo de planilha válido (.xls ou .xlsx).')
        return
      }
      this.arquivoSelecionado = arquivo
    },
    importar () {
      if (!this.arquivoSelecionado) {
        this.error('Selecione uma planilha para importar.')
        return
      }
      this.showLoading()
      var formData = new FormData()
      formData.append('arquivo', this.arquivoSelecionado)
      axios.post('api/v1/batimento/pagamentos/importacao/', formData).then((res) => {
        this.success('Planilha importada com sucesso!')
        this.getPagamentos()
        this.modalImportacao.active = false
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao importar a planilha.')
        this.closeLoading()
      })
    },
    editar (idx) {
      this.idxSelecionado = idx
      var pagamento = this.pagamentos[idx]
      this.formEdicao.data = Object.assign({}, pagamento)
      this.modalEditar.active = true
    },
    cancelarEdicao () {
      this.formEdicao.data = {}
      this.idxSelecionado = null
    },
    salvarEdicao () {
      var campoFaltante = this.camposObrigatoriosEdicao.find((campo) => {
        var valor = this.formEdicao.data[campo.name]
        return valor === undefined || valor === null || String(valor).trim() === ''
      })
      if (campoFaltante) {
        this.error(`Informe o campo "${campoFaltante.label}" antes de salvar.`)
        return
      }
      this.showLoading()
      var id = this.formEdicao.data.id
      axios.put(`api/v1/batimento/pagamentos/importacao/${id}/`, this.formEdicao.data).then((res) => {
        this.success('Pagamento atualizado com sucesso!')
        this.getPagamentos()
        this.modalEditar.active = false
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao atualizar o pagamento.')
        this.closeLoading()
      })
    },
    deletar (idx) {
      this.idxSelecionado = idx
      this.pagamentoSelecionado = this.pagamentos[idx]
      this.modalExcluir.active = true
    },
    cancelarExclusao () {
      this.idxSelecionado = null
      this.pagamentoSelecionado = null
    },
    confirmarExclusao () {
      if (!this.pagamentoSelecionado) {
        return
      }
      this.showLoading()
      axios.delete(`api/v1/batimento/pagamentos/importacao/${this.pagamentoSelecionado.id}/`).then((res) => {
        this.success('Pagamento excluído com sucesso!')
        this.getPagamentos()
        this.modalExcluir.active = false
        this.pagamentoSelecionado = null
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao excluir o pagamento.')
        this.closeLoading()
      })
    },
    getSelecionados () {
      return this.pagamentos.filter((p) => p.selecionado)
    },
    enviarParaAprovacao () {
      var selecionados = this.getSelecionados()
      if (selecionados.length === 0) {
        this.warning('Selecione ao menos um pagamento para enviar para aprovação.')
        return
      }
      this.showLoading()
      var ids = selecionados.map((p) => p.id)
      axios.post('api/v1/batimento/pagamentos/importacao/enviarpagamentoaprovacao/', { ids: ids }).then((res) => {
        this.success('Pagamento(s) enviado(s) para aprovação com sucesso!')
        this.getPagamentos()
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao enviar para aprovação.')
        this.closeLoading()
      })
    },
    deletarSelecionados () {
      var selecionados = this.getSelecionados()
      if (selecionados.length === 0) {
        this.warning('Selecione ao menos um pagamento para deletar.')
        return
      }
      this.showLoading()
      var ids = selecionados.map((p) => p.id)
      axios.delete('api/v1/batimento/pagamentos/importacao/excluir/', { data: { ids: ids } }).then((res) => {
        this.success('Pagamento(s) excluído(s) com sucesso!')
        this.getPagamentos()
        this.closeLoading()
      }).catch((err) => {
        this.error(err.response ? err.response.data : 'Erro ao excluir os pagamentos selecionados.')
        this.closeLoading()
      })
    }
  },
  computed: {
    totalSelecionados () {
      return this.pagamentos.filter((p) => p.selecionado).length
    },
    valorSelecionado () {
      return this.pagamentos
        .filter((p) => p.selecionado)
        .reduce((total, p) => total + Number(p.valor || 0), 0)
    },
    valorSelecionadoFormatado () {
      return `R$ ${utils.numberFormat(this.valorSelecionado)}`
    }
  }
}
</script>

<style lang="scss">
.drop-zone {
  position: relative;
  border: 2px dashed #b5b5b5;
  border-radius: 6px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  color: #4a4a4a;
}

.drop-zone:hover,
.drop-zone.is-dragover {
  border-color: #23d160;
  background-color: #f0fff4;
}

.drop-zone .file-input-hidden {
  display: none;
}

.modal-background {
  background-color: rgba(10, 10, 10, 0.21) !important;
}

.importacao-totais {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}
</style>
